import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatriculaHomeBarraComponent } from './matricula-home-barra/matricula-home-barra.component';
// import { ReconocimientosBarraComponent } from './reconocimientos-barra/reconocimientos-barra.component';
import { AdmisionesBarraComponent } from './admisiones-barra.component/admisiones-barra.component';
import { BarraSimpleComponent } from './barra-simple/barra-simple.component';
import { RouterModule } from '@angular/router';
import { ReunionesListaBarraComponent } from 'src/app/_modules/reuniones/reuniones-lista/reuniones-lista-barra.component';
import { ReunionBarraComponent } from 'src/app/_modules/reuniones/reunion/reunion-barra.component';
import { GLMMaterialDesignModule } from '../material-design/material-design.module';


@NgModule({
    declarations: [
        MatriculaHomeBarraComponent,
        // ReconocimientosBarraComponent,
        AdmisionesBarraComponent,
        BarraSimpleComponent,
        ReunionesListaBarraComponent,
        ReunionBarraComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        GLMMaterialDesignModule,
    ],
    exports: [
        MatriculaHomeBarraComponent,
        // ReconocimientosBarraComponent,
        AdmisionesBarraComponent,
        BarraSimpleComponent,
        ReunionesListaBarraComponent,
        ReunionBarraComponent,
    ]
})
export class GlmBarrasModule { }
